import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { loadDOMComponent } from '../../../../../helpers';
import { AppContextProvider } from '../../../../../Services/AppContext';
import { store } from '../../../../../store/store';
import DrawingInput from './DrawingInput';
import { parseRequired } from '../../../../../Utils/form.util';

loadDOMComponent({
	selector: 'react-drawing-input',
	callback: ({ container, context, props }: any) => {
		const name = container.getAttribute('name');
		const netteRules = container.getAttribute('data-nette-rules');
		const required = parseRequired(container.getAttribute('required'));

		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider {...context}>
					<DrawingInput
						name={name}
						netteRules={netteRules}
						isRequired={required}
					/>
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
